import {
  fetchInstagramReel,
  fetchInstagramReelsPaginated,
  fetchLatestInstagramReels,
  type InstagramReelsQueryFilters,
  type PaginatedInstagramReelsResult,
} from '@core/services/instagram-reels/instagram-reels-service'
import { CoreError, CoreErrorCause } from '@domain/models/core-error'
import type { InstagramReel } from '@domain/models/instagram-reel'
import type { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore'

export const MICHAEL_OKUN_INSTAGRAM_ACCOUNT_ID = '17841401146022163'
export const MICHAEL_OKUN_REELS_VIEW_ALL_URL =
  'https://www.instagram.com/michaelokun/reels/'

export class InstagramReelsFeature {
  public static async getLatestInstagramReels(
    count = 3,
    filters?: InstagramReelsQueryFilters,
  ): Promise<InstagramReel[]> {
    try {
      return await fetchLatestInstagramReels(
        MICHAEL_OKUN_INSTAGRAM_ACCOUNT_ID,
        count,
        filters,
      )
    } catch (error) {
      if (error instanceof CoreError) {
        throw error
      }
      throw new CoreError({
        cause: CoreErrorCause.Unknown,
        context: 'Failed to fetch latest Dr Michael Okun Instagram content.',
        underlyingException: error,
      })
    }
  }

  public static async getInstagramReel(reelId: string): Promise<InstagramReel> {
    try {
      return await fetchInstagramReel(reelId, MICHAEL_OKUN_INSTAGRAM_ACCOUNT_ID)
    } catch (error) {
      if (error instanceof CoreError) {
        throw error
      }
      throw new CoreError({
        cause: CoreErrorCause.Unknown,
        context: `Failed to fetch Instagram content "${reelId}".`,
        underlyingException: error,
      })
    }
  }

  public static async getInstagramReelsPaginated(
    pageSize: number,
    lastDocument?: QueryDocumentSnapshot<DocumentData> | null,
    filters?: InstagramReelsQueryFilters,
  ): Promise<PaginatedInstagramReelsResult> {
    try {
      return await fetchInstagramReelsPaginated(
        MICHAEL_OKUN_INSTAGRAM_ACCOUNT_ID,
        pageSize,
        lastDocument,
        filters,
      )
    } catch (error) {
      if (error instanceof CoreError) {
        throw error
      }
      throw new CoreError({
        cause: CoreErrorCause.Unknown,
        context: 'Failed to fetch paginated Dr Michael Okun Instagram content.',
        underlyingException: error,
      })
    }
  }
}

export async function getLatestInstagramReels(
  count = 3,
  filters?: InstagramReelsQueryFilters,
): Promise<InstagramReel[]> {
  return InstagramReelsFeature.getLatestInstagramReels(count, filters)
}

export async function getInstagramReel(reelId: string): Promise<InstagramReel> {
  return InstagramReelsFeature.getInstagramReel(reelId)
}

export async function getInstagramReelsPaginated(
  pageSize: number,
  lastDocument?: QueryDocumentSnapshot<DocumentData> | null,
  filters?: InstagramReelsQueryFilters,
): Promise<PaginatedInstagramReelsResult> {
  return InstagramReelsFeature.getInstagramReelsPaginated(
    pageSize,
    lastDocument,
    filters,
  )
}

export type { PaginatedInstagramReelsResult }
